<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="all_menu_team">
            <!-- <v-card class="list_menu_team">
                <router-link to="/intimework" class="menu_card_team d-flex flex-column justify-center align-center">
                    <div class="img_menu_team">
                        <img src="@/assets/stopwatch.png">
                    </div>
                    <div class="title_menu_team">
                        ลงเวลาการทำงาน
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_team">
                <router-link to="/workschedule" class="menu_card_team d-flex flex-column justify-center align-center">
                    <div class="img_menu_team">
                        <img src="@/assets/schedule_1.png">
                    </div>
                    <div class="title_menu_team">
                        ตารางการทำงาน
                    </div>
                </router-link>
            </v-card> -->

            <!-- <v-card class="list_menu_team">
                <router-link to="/leavework" class="menu_card_team d-flex flex-column justify-center align-center">
                    <div class="img_menu_team">
                        <img src="@/assets/contact-form.png">
                    </div>
                    <div class="title_menu_team">
                        ลางาน
                    </div>
                </router-link>
            </v-card> -->
            <v-card class="list_menu_team" v-if="$store.state.userProfile.per_my_team == 1 || $store.state.userProfile.per_add_team == 1">
                <router-link to="/myteam" class="menu_card_team d-flex flex-column justify-center align-center"  v-if="$store.state.userProfile.per_my_team == 1">
                    <div class="img_menu_team">
                        <img src="@/assets/team.png">
                    </div>
                    <div class="title_menu_team">
                        ทีมงานของฉัน
                    </div>
                </router-link>
                <router-link to="/addteam" class="menu_card_team d-flex flex-column justify-center align-center"  v-else-if=" $store.state.userProfile.per_add_team == 1">
                    <div class="img_menu_team">
                        <img src="@/assets/team.png">
                    </div>
                    <div class="title_menu_team">
                        ทีมงานของฉัน
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_team">
                <router-link to="/dayoffrestaurant" class="menu_card_team d-flex flex-column justify-center align-center">
                    <div class="img_menu_team">
                        <img src="@/assets/settings.png">
                    </div>
                    <div class="title_menu_team">
                        ตั้งค่า
                    </div>
                </router-link>
            </v-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'team',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true
        }
    },
    methods: {
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
    },
    mounted() {
        this.buffetList()
    }
}
</script>

<style scoped>
.all_menu_team{
    display:grid;
    grid-template-columns: 50% 50%;
    grid-row-gap: 8px;
}

.list_menu_team {
    padding: 15px;
}

.list_menu_team:nth-child(odd) {
    margin-right: 4px;
}

.list_menu_team:nth-child(even) {
    margin-left: 4px;
}

.list_menu_team:hover {
    background: linear-gradient(to top, #038cc1 , #55c0e9)!important;
    transition: 0.1s !important;
}

.list_menu_team:hover>.menu_card_team {
    color: #fff !important;
}

.menu_card_team {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_team {
    width: 100px;
}

.img_menu_team>img {
    max-width: 100%;
}

.title_menu_team {
    font-size: 20px;
}
</style>
